﻿import { GroCommon, UploadImageModule } from './common';

$(document).ready(function () {
    var facilityEditInformationPage = new FacilityEditInformationPage();
    facilityEditInformationPage.init();
    $(document).on('change', 'select', function () {
        //Check whether option with value  exists
        var option = $("option[value='" + this.value + "']", this);
        if (option && option.length > 0) {
            option.attr('selected', true).siblings().removeAttr('selected');
        }
    });
    // enhance table saw to make responsive table
    $(document).trigger('enhance.tablesaw');
});

var FacilityEditInformationFunction =
    FacilityEditInformationFunction ||
    (function () {
        var blockFacilityEditInfoUI = function () {
            $('#facilityEditInfoLoader').show();
        };
        var unBlockFacilityEditInfoUI = function () {
            $('#facilityEditInfoLoader').hide();
        };

        var facilityEditInfoFillContentToModal = function (
            header,
            content,
            openDialog,
            dialogType,
            callback
        ) {
            var dialogArea = $('#facilityEditInfoDialogArea');
            var iconElement = dialogArea.find('span.popup-type');
            if (dialogType) {
                iconElement.removeClass('hidden');
                iconElement.addClass(GroCommon.getModalIconClass(dialogType));
            } else {
                iconElement.addClass('hidden');
            }

            dialogArea.find('.lm__wide-modal__title').html(header);
            dialogArea.find('p').append(content);
            dialogArea.find('.btn-ok').on('click', function () {
                dialogArea.addClass('hidden');
                if (callback) {
                    callback();
                }
            });
            if (openDialog) {
                dialogArea.removeClass('hidden');
            }
        };
        var facilityEditInfoClearContentToModal = function () {
            var dialogArea = $('#facilityEditInfoDialogArea');
            dialogArea.find('span.alert-icon.popup-type').removeClass('warning success info-icon');
            dialogArea.find('.lm__wide-modal__title').html('');
            dialogArea.find('p').html('');
            dialogArea.find('.btn-ok').unbind('click');
        };
        var facilityEditInfoFillContentToConfirmDialog = function (
            header,
            content,
            okCallback,
            cancelCallBack
        ) {
            var dialogArea = $('#facilityEditInfoConfirmDialog');
            dialogArea.find('.modal-header-title').html(header);
            dialogArea.find('p').append(content);
            dialogArea.find('.btn-cancel').on('click', function () {
                dialogArea.hide();
                if (cancelCallBack) cancelCallBack();
            });
            dialogArea.find('.btn-ok').on('click', function () {
                dialogArea.hide();
                if (okCallback) {
                    okCallback();
                }
            });
            dialogArea.show();
        };
        var facilityEditInfoClearContentToConfirmDialog = function () {
            var dialogArea = $('#facilityEditInfoConfirmDialog');
            dialogArea.find('.lm__wide-modal__title').html('');
            dialogArea.find('p').html('');
            dialogArea.find('.btn-ok').unbind('click');
            dialogArea.find('.btn-cancel').unbind('click');
        };

        var clearFacilityEditInfoOpeningHoursValidation = function (selector) {
            for (var index = 0; index < 7; index++) {
                $('#' + selector + index).hide();
            }
        };
        var facilityAddressTypeEnum = {
            PrimaryAddress: 1,
            SecondaryAddress: 2,
        };
        var isSecondaryAddressActivated = function () {
            return $("input[id='js-activate-secondary-address']").is(':checked');
        };
        var clearFacilityEditAddressValidations = function (facilityAddressType) {
            $('#facilityAddressVisitingAddress1Error_' + facilityAddressType).hide();
            $('#facilityAddressVisitingAddress2Error_' + facilityAddressType).hide();
            $('#facilityAddressZipCodeError_' + facilityAddressType).hide();
            $('#facilityAddressCityError_' + facilityAddressType).hide();
            $('#facilityAddressCountryError_' + facilityAddressType).hide();
            $('#facilityAddressLatitudeError_' + facilityAddressType).hide();
            $('#facilityAddressLongitudeError_' + facilityAddressType).hide();
            $('#facilityAddressPhoneNumberError_' + facilityAddressType).hide();
        };
        var clearFacilityEditInfoValidations = function () {
            $('#facilityEditInfoOwnerError').hide();
            $('#facilityEditInfoNameError').hide();
            clearFacilityEditAddressValidations(facilityAddressTypeEnum.PrimaryAddress);
            clearFacilityEditAddressValidations(facilityAddressTypeEnum.SecondaryAddress);
            $('#facilityEditInfoHarvestPeriodFromDateError').hide();
            clearFacilityEditInfoOpeningHoursValidation(
                'facilityEditInfoNormalPeriodFromHourError_'
            );
            clearFacilityEditInfoOpeningHoursValidation(
                'facilityEditInfoHarvestPeriodFromHourError_'
            );
            $('#facilityEditInfoPhoneNumberError').hide();
            $('#facilityEditInfoExtraPhoneNumberError').hide();
            $('#facilityEditInfoPhoneBookingError').hide();
            $('#facilityEditInfoPhoneAnsweringMachineError').hide();
            $('#facilityEditInfoFaxError').hide();
            $('#facilityEditInfoEmailError').hide();
            $('#facilityEditInfoWebsiteError').hide();
            $('#facilityEditInfoOtherInformationError').hide();
            $('#facilityEditInfoHarvestPeriodInformationError').hide();
            $('#facilityEditInfoLanguageError').hide();
            $('#facilityEditInfoPropertyTypeError').hide();
        };
        var validateFacilityEditInfoOpeningHours = function (openingHours, selector) {
            var result = true;
            for (var index = 0; index < openingHours.length; index++) {
                var openingHour = openingHours[index];
                if ($.trim(openingHour.FromHour) == '' && $.trim(openingHour.ToHour) != '') {
                    $('#' + selector + index).show();
                    result = false;
                } else if ($.trim(openingHour.FromHour) != '' && $.trim(openingHour.ToHour) == '') {
                    $('#' + selector + index).show();
                    result = false;
                } else if ($.trim(openingHour.FromHour) != '' && $.trim(openingHour.ToHour) != '') {
                    var fromHour = parseInt($.trim(openingHour.FromHour.replace(/_/g, '')));
                    var toHour = parseInt($.trim(openingHour.ToHour.replace(/_/g, '')));
                    if (fromHour == 0) fromHour = 2400;
                    if (toHour == 0) toHour = 2400;
                    if (toHour < fromHour) {
                        $('#' + selector + index).show();
                        result = false;
                    }
                }
            }
            return result;
        };
        var validateFacilityEditAddress = function (facilityAddress) {
            var result = true;
            var rePhone = /^((((0{2}?)|(\+){1})46)|0)7[\d]{8}/;

            var facilityAddressType = facilityAddress.AddressType;

            if (
                $.trim(facilityAddress.VisitingAddress) == '' ||
                $.trim(facilityAddress.VisitingAddress).length > 255
            ) {
                result = false;
                $('#facilityAddressVisitingAddress1Error_' + facilityAddressType).show();
            }
            if (
                $.trim(facilityAddress.VisitingAddress2) != '' &&
                $.trim(facilityAddress.VisitingAddress2).length > 255
            ) {
                result = false;
                $('#facilityAddressVisitingAddress2Error_' + facilityAddressType).show();
            }
            if (
                $.trim(facilityAddress.Region) != '' &&
                $.trim(facilityAddress.Region).length > 50
            ) {
                result = false;
                $('#facilityAddressRegionError_' + facilityAddressType).show();
            }
            if (
                $.trim(facilityAddress.ZipCode) == '' ||
                $.trim(facilityAddress.ZipCode).length > 20
            ) {
                result = false;
                $('#facilityAddressZipCodeError_' + facilityAddressType).show();
            }
            if ($.trim(facilityAddress.City) == '' || $.trim(facilityAddress.City).length > 50) {
                result = false;
                $('#facilityAddressCityError_' + facilityAddressType).show();
            }
            if ($.trim(facilityAddress.CountryId) == '') {
                result = false;
                $('#facilityAddressCountryError_' + facilityAddressType).show();
            }
            if (
                $.trim(facilityAddress.Latitude) == '' ||
                $.trim(facilityAddress.Latitude).length > 20
            ) {
                result = false;
                $('#facilityAddressLatitudeError_' + facilityAddressType).show();
            }
            if (
                $.trim(facilityAddress.Longitude) == '' ||
                $.trim(facilityAddress.Longitude).length > 20
            ) {
                result = false;
                $('#facilityAddressLongitudeError_' + facilityAddressType).show();
            }
            if (
                $.trim(facilityAddress.PhoneNumber) != '' &&
                $.trim(facilityAddress.PhoneNumber).length > 20
            ) {
                result = false;
                $('#facilityAddressPhoneNumberError_' + facilityAddressType).show();
            }
            return result;
        };
        var validateFacilityEditInfoSave = function (data) {
            var rePhone = /^((((0{2}?)|(\+){1})46)|0)7[\d]{8}/;
            var reEmail =
                /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
            var reWebsite =
                /^(http(s)?:\/\/)(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#()?&//=]*)$/;
            var result = true;
            clearFacilityEditInfoValidations();
            if (data) {
                var facilityName = $.trim(data.FacilityName);
                if (facilityName == '' || facilityName.length > 255) {
                    result = false;
                    $('#facilityEditInfoNameError').show();
                }
                var facilityOwner = $.trim(data.FacilityOwnerId);
                if (facilityOwner == '') {
                    result = false;
                    $('#facilityEditInfoOwnerError').show();
                }
                if ($.trim(data.FacilityPropertyType) == '') {
                    result = false;
                    $('#facilityEditInfoPropertyTypeError').show();
                }
                if ($.trim(data.LanguageCode) == '') {
                    result = false;
                    $('#facilityEditInfoLanguageError').show();
                }
                if (
                    $.trim(data.ExtraPhoneNumber) != '' &&
                    $.trim(data.ExtraPhoneNumber).length > 20
                ) {
                    result = false;
                    $('#facilityEditInfoExtraPhoneNumberError').show();
                }
                if ($.trim(data.PhoneBooking) != '' && $.trim(data.PhoneBooking).length > 50) {
                    result = false;
                    $('#facilityEditInfoPhoneBookingError').show();
                }
                if (
                    $.trim(data.PhoneAnsweringMachine) != '' &&
                    $.trim(data.PhoneAnsweringMachine).length > 20
                ) {
                    result = false;
                    $('#facilityEditInfoPhoneAnsweringMachineError').show();
                }
                if ($.trim(data.Fax) != '' && $.trim(data.Fax).length > 20) {
                    result = false;
                    $('#facilityEditInfoFaxError').show();
                }
                var email = $.trim(data.Email);
                if (email !== '' && (email.length > 255 || !reEmail.test(email))) {
                    result = false;
                    $('#facilityEditInfoEmailError').show();
                }
                var website = $.trim(data.Website);
                if (website !== '' && (website.length > 255 || !reWebsite.test(website))) {
                    result = false;
                    $('#facilityEditInfoWebsiteError').show();
                }
                if (
                    $.trim(data.OtherInformation) != '' &&
                    $.trim(data.OtherInformation).length > 1200
                ) {
                    result = false;
                    $('#facilityEditInfoOtherInformationError').show();
                }
                if (
                    $.trim(data.HarvestPeriod.FromDate) == '' &&
                    $.trim(data.HarvestPeriod.ToDate) != ''
                ) {
                    result = false;
                    $('#facilityEditInfoHarvestPeriodFromDateError').show();
                } else if (
                    $.trim(data.HarvestPeriod.FromDate) != '' &&
                    $.trim(data.HarvestPeriod.ToDate) == ''
                ) {
                    result = false;
                    $('#facilityEditInfoHarvestPeriodFromDateError').show();
                } else if (
                    $.trim(data.HarvestPeriod.FromDate) != '' &&
                    $.trim(data.HarvestPeriod.ToDate) != ''
                ) {
                    var fromDate = new Date(data.HarvestPeriod.FromDate);
                    var toDate = new Date(data.HarvestPeriod.ToDate);
                    if (toDate < fromDate) {
                        result = false;
                        $('#facilityEditInfoHarvestPeriodFromDateError').show();
                    }
                }
                var harvestPeriodOtherInformation = data.HarvestPeriod.OtherInformation;
                if (
                    $.trim(harvestPeriodOtherInformation) !== '' &&
                    harvestPeriodOtherInformation.length > 1200
                ) {
                    result = false;
                    $('#facilityEditInfoHarvestPeriodOtherInformationError').show();
                }
                var isFacilityPrimaryAddressValid = validateFacilityEditAddress(
                    data.PrimaryAddress
                );
                var isFacilitySecondaryAddressValid = isSecondaryAddressActivated()
                    ? validateFacilityEditAddress(data.SecondaryAddress)
                    : true;
                var areNormalPeriodOpeningHoursValid = validateFacilityEditInfoOpeningHours(
                    data.NormalPeriod.OpeningHours,
                    'facilityEditInfoNormalPeriodFromHourError_'
                );
                var areHarvestPeriodOpeningHoursValid = validateFacilityEditInfoOpeningHours(
                    data.HarvestPeriod.OpeningHours,
                    'facilityEditInfoHarvestPeriodFromHourError_'
                );
                result =
                    result &&
                    isFacilityPrimaryAddressValid &&
                    isFacilitySecondaryAddressValid &&
                    areNormalPeriodOpeningHoursValid &&
                    areHarvestPeriodOpeningHoursValid;
            }

            return result;
        };
        var disableFacilityEditInfoButtons = function () {
            //$("#createNewFacility").addClass("disabled-btn");
            $('#saveFacilityInfoBtn').addClass('disabled-btn');
            $('#cancelFacilityInfoBtn').addClass('disabled-btn');
            $('.js-facility-connected-contact-persons').addClass('disabled-btn');
            $('.js-facility-contact-person-information').addClass('disabled-btn');
        };
        var enableFacilityEditInfoButtons = function () {
            //$("#createNewFacility").removeClass("disabled-btn");
            $('#saveFacilityInfoBtn').removeClass('disabled-btn');
            $('#cancelFacilityInfoBtn').removeClass('disabled-btn');
            $('.js-facility-connected-contact-persons').removeClass('disabled-btn');
            $('.js-facility-contact-person-information').removeClass('disabled-btn');
        };

        var primaryFacilityAddressMap = null;
        var primaryFacilityAddressMarker = null;
        var secondaryFacilityAddressMap = null;
        var secondaryFacilityAddressMarker = null;

        var addressComponents = {
            street_number: 'street_number',
            route: 'route',
            premise: 'premise',
            locality: 'locality',
            sublocality_level_1: 'sublocality_level_1',
            administrative_area_level_1: 'administrative_area_level_1',
            country: 'country',
            postal_code: 'postal_code',
            postal_town: 'postal_town',
        };
        var getFacilityAddressMarker = function (facilityAddressType) {
            return facilityAddressType == facilityAddressTypeEnum.PrimaryAddress
                ? primaryFacilityAddressMarker
                : secondaryFacilityAddressMarker;
        };
        var getFacilityAddressMap = function (facilityAddressType) {
            return facilityAddressType == facilityAddressTypeEnum.PrimaryAddress
                ? primaryFacilityAddressMap
                : secondaryFacilityAddressMap;
        };

        var getCurrentPosition = function () {
            //stockholm by default
            var currentPosition = {
                lat: '59.325',
                lng: '18.070',
            };
            Notification.requestPermission(function (result) {
                if (result === 'denied') {
                    console.log("Permission wasn't granted. Allow a retry.");
                    return;
                } else if (result === 'default') {
                    console.log('The permission request was dismissed.');
                    return;
                }
                console.log('Permission was granted for notifications');
            });
            // Check for Geolocation API permissions
            navigator.permissions.query({ name: 'geolocation' }).then(function (permissionStatus) {
                console.log('geolocation permission state is ', permissionStatus.state);

                permissionStatus.onchange = function () {
                    console.log('geolocation permission state has changed to ', this.state);
                };
            });
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (position) {
                    currentPosition = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    };
                });
            }
            return currentPosition;
        };
        //This function will get the marker's current location and then add the lat/long
        //values to our textfields so that we can save the location.
        function markFacilityAddressLocation(facilityAddressMarker, facilityAddressType) {
            var facilityAddressMapFrame = document.getElementById(
                'FacilityAddressMapFrame_' + facilityAddressType
            );

            var facilityAddressMap = getFacilityAddressMap(facilityAddressType);

            //Get location.
            if (facilityAddressMarker) {
                var currentLocation = facilityAddressMarker.getPosition();

                var latitude = currentLocation.lat(); //latitude
                var longitude = currentLocation.lng(); //longitude

                var lat = parseFloat(latitude).toFixed(6);
                var lng = parseFloat(longitude).toFixed(6);
                var latLng = new google.maps.LatLng(lat, lng);

                var facilityAddressMapFrameSrc =
                    'https://www.google.com/maps/embed/v1/place?q=' +
                    latLng.lat() +
                    ',' +
                    latLng.lng() +
                    '&maptype=satellite&zoom=18&key=' +
                    $('#FacilityAddressGoogleMapsAPIKey_' + facilityAddressType).val();
                $(facilityAddressMapFrame).attr('src', facilityAddressMapFrameSrc);

                // Update input fields
                $('#FacilityAddressLatitude_' + facilityAddressType).val(lat);
                $('#FacilityAddressLongitude_' + facilityAddressType).val(lng);

                // update position
                facilityAddressMarker.setPosition(latLng);

                facilityAddressMarker.setMap(facilityAddressMap);
            } else {
                $(facilityAddressMapFrame).attr('src', '');
                // Update input fields
                $('#FacilityAddressLatitude_' + facilityAddressType).val('');
                $('#FacilityAddressLongitude_' + facilityAddressType).val('');

                facilityAddressMarker.setMap(null);
            }
        }
        var clearFacilityAddressComponents = function (facilityAddressType) {
            $("input[id='FacilityAddressVisitingAddress1_" + facilityAddressType + "']").val('');
            $("input[id='FacilityAddressVisitingAddress2_" + facilityAddressType + "']").val('');
            $("input[id='FacilityAddressZipCode_" + facilityAddressType + "']").val('');
            $("input[id='FacilityAddressCity_" + facilityAddressType + "']").val('');
            $('.facility-address-country-dropdown-' + facilityAddressType)
                .val('')
                .trigger('change', { showAreas: false });
            $('.facility-address-area-dropdown-' + facilityAddressType)
                .val('')
                .trigger('change', { showRegions: false });
            $('.facility-address-region-dropdown-' + facilityAddressType)
                .val('')
                .change();
            $("input[id='FacilityAddressLatitude_" + facilityAddressType + "']").val('');
            $("input[id='FacilityAddressLongitude_" + facilityAddressType + "']").val('');
            $("input[id='FacilityAddressPhoneNumber_" + facilityAddressType + "']").val('');
        };
        var initializeFacilityAddressMapEvents = function (
            autoComplete,
            facilityAddressType,
            defaultBounds
        ) {
            var autoCompleteElement = document.getElementById(
                'FacilityAddressAutoCompleteAddress_' + facilityAddressType
            );

            var facilityAddressMap = getFacilityAddressMap(facilityAddressType);

            var facilityAddressMarker = getFacilityAddressMarker(facilityAddressType);

            // Listen for the event fired when the user selects a prediction and retrieve
            // more details for that place.
            $(autoCompleteElement).focus(function () {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        var geolocation = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                        };
                        var circle = new google.maps.Circle({
                            center: geolocation,
                            radius: position.coords.accuracy,
                        });
                        autoComplete.setBounds(circle.getBounds());
                    });
                }
            });

            // Listen for the event fired when the user selects a prediction and retrieve
            // more details for that place.
            google.maps.event.addListener(autoComplete, 'place_changed', function () {
                // Clear out the old markers.
                facilityAddressMarker.setMap(null);

                $(autoCompleteElement).val('');

                clearFacilityAddressComponents(facilityAddressType);
                clearFacilityEditAddressValidations(facilityAddressType);

                // Get the place details from the autoComplete object.
                var place = autoComplete.getPlace();

                if (place == null) {
                    return;
                }

                if (!place.geometry) {
                    console.log('Returned place contains no geometry');
                    return;
                }
                //var icon = {
                //    url: place.icon,
                //    size: new google.maps.Size(71, 71),
                //    origin: new google.maps.Point(0, 0),
                //    anchor: new google.maps.Point(17, 34),
                //    scaledSize: new google.maps.Size(25, 25)
                //};
                // Create a marker for each place.
                facilityAddressMarker = new google.maps.Marker({
                    map: facilityAddressMap,
                    //icon: icon,
                    //title: place.name,
                    position: place.geometry.location,
                });

                if (place.geometry.viewport) {
                    // Only geocodes have viewport.
                    defaultBounds.union(place.geometry.viewport);
                } else {
                    defaultBounds.extend(place.geometry.location);
                }

                facilityAddressMap.fitBounds(defaultBounds);
                var streetNumber = '';
                // Get each component of the address from the place details,
                // and then fill-in the corresponding field on the form.
                for (var i = 0; i < place.address_components.length; i++) {
                    var addressComponent = place.address_components[i];
                    var addressComponentType = addressComponent.types[0];
                    var addressComponentValue = addressComponent.long_name;
                    switch (addressComponentType) {
                        case addressComponents.premise:
                        case addressComponents.route:
                        case addressComponents.sublocality_level_1: {
                            var address = $.trim(
                                $(
                                    "input[id='FacilityAddressVisitingAddress1_" +
                                        facilityAddressType +
                                        "']"
                                ).val()
                            );
                            if (address == '') {
                                if (streetNumber != '') {
                                    address = addressComponentValue + ' ' + streetNumber; // adding street number to existing address
                                } else {
                                    address = addressComponentValue;
                                }
                                $(
                                    "input[id='FacilityAddressVisitingAddress1_" +
                                        facilityAddressType +
                                        "']"
                                ).val(address);
                                streetNumber = '';
                            }
                            break;
                        }
                        case addressComponents.street_number: {
                            streetNumber = addressComponentValue;
                            break;
                        }
                        case addressComponents.administrative_area_level_1: {
                            if (
                                $.trim(
                                    $(
                                        "input[id='FacilityAddressRegion_" +
                                            facilityAddressType +
                                            "']"
                                    ).val()
                                ) == ''
                            )
                                $(
                                    "input[id='FacilityAddressRegion_" + facilityAddressType + "']"
                                ).val(addressComponentValue);
                            break;
                        }
                        case addressComponents.postal_town:
                        case addressComponents.locality: {
                            if (
                                $.trim(
                                    $(
                                        "input[id='FacilityAddressCity_" +
                                            facilityAddressType +
                                            "']"
                                    ).val()
                                ) == ''
                            )
                                $(
                                    "input[id='FacilityAddressCity_" + facilityAddressType + "']"
                                ).val(addressComponentValue);
                            break;
                        }
                        case addressComponents.postal_code: {
                            if (
                                $.trim(
                                    $(
                                        "input[id='FacilityAddressZipCode_" +
                                            facilityAddressType +
                                            "']"
                                    ).val()
                                ) == ''
                            )
                                $(
                                    "input[id='FacilityAddressZipCode_" + facilityAddressType + "']"
                                ).val(addressComponentValue);
                            break;
                        }
                    }
                }
                markFacilityAddressLocation(facilityAddressMarker, facilityAddressType);
            });

            // current map's viewport.
            google.maps.event.addListener(facilityAddressMap, 'bounds_changed', function () {
                var bounds = facilityAddressMap.getBounds();
                autoComplete.setBounds(bounds);
            });

            google.maps.event.addListener(facilityAddressMarker, 'dragend', function (event) {
                markFacilityAddressLocation(facilityAddressMarker, facilityAddressType);
            });
            google.maps.event.addListener(facilityAddressMap, 'click', function (event) {
                if (facilityAddressMarker) {
                    // If primaryFacilityAddressMarker already exists, update position
                    facilityAddressMarker.setPosition(event.latLng);
                } else {
                    // It not, create a new primaryFacilityAddressMarker
                    facilityAddressMarker = new google.maps.Marker({
                        position: event.latLng,
                        map: facilityAddressMap,
                    });
                }
                markFacilityAddressLocation(facilityAddressMarker, facilityAddressType);
            });
        };

        var initializeFacilityAddressMap = function (facilityAddressType) {
            var mapElement = document.getElementById('FacilityAddressMap_' + facilityAddressType);

            if (mapElement && typeof google === 'object') {
                var currentPosition = getCurrentPosition();

                var latitude = $('#FacilityAddressLatitude_' + facilityAddressType).val();
                var longitude = $('#FacilityAddressLongitude_' + facilityAddressType).val();
                var latLng = null;

                if (latitude && longitude) {
                    // Existing address
                    var lat = parseFloat(latitude).toFixed(6);
                    var lng = parseFloat(longitude).toFixed(6);
                    latLng = new google.maps.LatLng(lat, lng);
                } else {
                    var startLat = parseFloat(currentPosition.lat).toFixed(6);
                    var startLng = parseFloat(currentPosition.lng).toFixed(6);
                    latLng = new google.maps.LatLng(startLat, startLng);
                }

                var defaultBounds = new google.maps.LatLngBounds(latLng);

                var mapOptions = {
                    zoom: 18,
                    center: { lat: latLng.lat(), lng: latLng.lng() },
                    mapTypeId: 'hybrid',
                };

                if (facilityAddressType == facilityAddressTypeEnum.PrimaryAddress) {
                    primaryFacilityAddressMap = new google.maps.Map(mapElement, mapOptions);

                    primaryFacilityAddressMarker = new google.maps.Marker({
                        position: latLng,
                        map: primaryFacilityAddressMap,
                    });

                    primaryFacilityAddressMap.fitBounds(defaultBounds);

                    // update position
                    primaryFacilityAddressMarker.setPosition(latLng);

                    primaryFacilityAddressMarker.setMap(primaryFacilityAddressMap);
                } else {
                    secondaryFacilityAddressMap = new google.maps.Map(mapElement, mapOptions);

                    secondaryFacilityAddressMarker = new google.maps.Marker({
                        position: latLng,
                        map: secondaryFacilityAddressMap,
                    });

                    secondaryFacilityAddressMap.fitBounds(defaultBounds);

                    // update position
                    secondaryFacilityAddressMarker.setPosition(latLng);

                    secondaryFacilityAddressMarker.setMap(secondaryFacilityAddressMap);
                }

                var autoCompleteElement = document.getElementById(
                    'FacilityAddressAutoCompleteAddress_' + facilityAddressType
                );

                // Create the autoComplete object, restricting the search predictions to
                // geographical location types.
                var autoComplete = new google.maps.places.Autocomplete(autoCompleteElement, {
                    types: ['geocode'],
                });

                autoComplete.setBounds(defaultBounds);

                // Avoid paying for data that you don't need by restricting the set of
                // place fields that are returned to just the address components.
                autoComplete.setFields(['address_component', 'geometry']);

                initializeFacilityAddressMapEvents(
                    autoComplete,
                    facilityAddressType,
                    defaultBounds
                );
            }
        };

        var inactivateSecondaryAddress = function () {
            clearFacilityAddressComponents(facilityAddressTypeEnum.SecondaryAddress);
            clearFacilityEditAddressValidations(facilityAddressTypeEnum.SecondaryAddress);
            $('.js-secondary-address').addClass('hidden');
            $("input[id='js-activate-secondary-address']").prop('checked', false);
        };
        return {
            blockFacilityEditInfoUI: blockFacilityEditInfoUI,
            unBlockFacilityEditInfoUI: unBlockFacilityEditInfoUI,
            facilityEditInfoFillContentToModal: facilityEditInfoFillContentToModal,
            facilityEditInfoClearContentToModal: facilityEditInfoClearContentToModal,
            facilityEditInfoFillContentToConfirmDialog: facilityEditInfoFillContentToConfirmDialog,
            facilityEditInfoClearContentToConfirmDialog:
                facilityEditInfoClearContentToConfirmDialog,
            validateFacilityEditInfoSave: validateFacilityEditInfoSave,
            clearFacilityEditInfoValidations: clearFacilityEditInfoValidations,
            enableFacilityEditInfoButtons: enableFacilityEditInfoButtons,
            disableFacilityEditInfoButtons: disableFacilityEditInfoButtons,
            initializeFacilityAddressMap: initializeFacilityAddressMap,
            getFacilityAddressMap: getFacilityAddressMap,
            getFacilityAddressMarker: getFacilityAddressMarker,
            markFacilityAddressLocation: markFacilityAddressLocation,
            inactivateSecondaryAddress: inactivateSecondaryAddress,
            facilityAddressTypeEnum: facilityAddressTypeEnum,
            isSecondaryAddressActivated: isSecondaryAddressActivated,
        };
    })();

var FacilityEditInformationPage = function () {
    var dialogType = GroCommon.modalInfoClass;
    var hideFacilityContactPersonInformation = function () {
        $('.js-hide-show-facility-contact-person-information').hide();
    };

    var showFacilityContactPersonInformation = function () {
        $('.js-hide-show-facility-contact-person-information').show();
    };
    var hideFacilityEditInformation = function () {
        $('.js-hide-show-facility-edit-information').hide();
        $('.js-hide-show-facilities-by-owner-information').hide();
    };

    var showFacilityEditInformation = function () {
        $('.js-hide-show-facility-edit-information').show();
        $('.js-hide-show-facilities-by-owner-information').hide();
    };
    var showFacilitiesByOwnersList = function () {
        $('.js-hide-show-facilities-by-owner-information').show();
        $('.js-hide-show-facility-edit-information').hide();
    };
    var getCurrentlySelectedFacilityOwner = function () {
        return $('.facility-owner-dropdown :selected').val();
    };
    var getCurrentlySelectedFacilityOwnerName = function () {
        return $('.facility-owner-dropdown :selected').text();
    };
    var getCurrentlySelectedFacilityType = function () {
        return $('input[name="facilityTypes[]"]')
            .filter(function () {
                return this.checked;
            })
            .map(function () {
                return this.value;
            })
            .get()
            .join(',');
    };
    var getCurrentlySelectedFacilityId = function () {
        return $('#SelectedFacilityId').val();
    };
    var getCurrentlySelectedFacilityPropertyType = function () {
        return $('#FacilityPropertyType').val();
    };
    var showFacilityContactPersonInformationLoader = function () {
        $('#loader-facility-contact-person-information').show();
    };
    var hideFacilityContactPersonInformationLoader = function () {
        $('#loader-facility-contact-person-information').hide();
    };
    var showFacilityContactPersonsLoader = function () {
        $('#facility-connected-contact-persons-loader').show();
    };
    var hideFacilityContactPersonsLoader = function () {
        $('#facility-connected-contact-persons-loader').hide();
    };
    var showSaveFacilityInformationLoader = function () {
        $('#saveFacilityInformationLoader').show();
    };
    var hideSaveFacilityInformationLoader = function () {
        $('#saveFacilityInformationLoader').hide();
    };
    var getCurrentlySelectedFacilityContactPersonId = function () {
        return $('#connectedContactPersonId').val();
    };
    var getCurrentlySelectedFacilityContactPersonName = function () {
        return $('.facility-contact-person-dropdown :selected').text();
    };

    var getConnectedContactPersonIds = function () {
        return $('.js-facility-connected-contact-persons')
            .filter(function () {
                return $(this).hasClass('active');
            })
            .map(function () {
                return $(this).data('contactpersonid');
            })
            .get()
            .join(',');
    };
    var getCurrentlySelectedCountryId = function (facilityAddressType) {
        return $('#FacilityAddressCountry_' + facilityAddressType + ' :selected').val();
    };
    var getCurrentlySelectedAreaId = function (facilityAddressType) {
        return $('#FacilityAddressArea_' + facilityAddressType + ' :selected').val();
    };
    var getCurrentlySelectedRegionId = function (facilityAddressType) {
        return $('#FacilityAddressRegion_' + facilityAddressType + ' :selected').val();
    };
    var getCurrentlySelectedCountry = function (facilityAddressType) {
        return $('#FacilityAddressCountry_' + facilityAddressType + ' :selected').text();
    };
    var getCurrentlySelectedArea = function (facilityAddressType) {
        return $('#FacilityAddressArea_' + facilityAddressType + ' :selected').text();
    };
    var getCurrentlySelectedRegion = function (facilityAddressType) {
        return $('#FacilityAddressRegion_' + facilityAddressType + ' :selected').text();
    };
    var getCurrentlySelectedLanguageCode = function () {
        return $('#LanguageCode :selected').val();
    };
    var getCurrentlySelectedLanguage = function () {
        var regExp = /\(([^)]+)\)/;
        var languageCode = $.trim($('#LanguageCode :selected').text());
        return regExp.exec(languageCode)[1];
    };
    var getShowFacilityInfo = function () {
        return $("input[id='showHideFacilityEditInfo']").is(':checked');
    };
    var getIsInternal = function () {
        return $.trim($("input[id='IsInternal']").val());
    };
    var addFacilityEditInfoUploadPopupEvent = function () {
        $(document).on('click', function () {
            $('.popup-sub').fadeOut();
        });

        //$(".popup-sub").click(function () { return false; });
        $('.lm__avatar .lm__avatar__upload-btn').click(function () {
            var popupSub = $(this).parent();
            if (popupSub.has('.popup-sub')) {
                popupSub.find('.popup-sub').fadeToggle();
            }
            return false;
        });
    };
    function getFacilityEditInfoImageUploadSettings() {
        return {
            fileSelector: '#facility-edit-info-avatar__file',
            previewImgSelector: '#facility-edit-info-avatar',
            uploadBtnSelector: '#facility-edit-info-uploadBtn',
            cancelUploadBtnSelector: '#facility-edit-info-cancelUpload',
            linkSelector: '#facility-edit-info-link',
            handleUrl: '/api/facility-edit-information/upload-facility-information-image',
            deleteLinkSelector: '#facility-edit-info-deleteBtn',
            handleDeleteUrl: '/api/facility-edit-information/delete-facility-information-image',
            isNeedToUpdateHeader: false,
            messages: {
                confirmationDialogSelector: '#dialog-facility-edit-info-confirmation',
            },
        };
    }

    var initFacilityEditInfoImageUploadEvent = function () {
        addFacilityEditInfoUploadPopupEvent();
        //Init for Customer picture
        var facilityEditInfoImageUploadSettings = getFacilityEditInfoImageUploadSettings();
        var facilityEditInfoImageUploadModule = UploadImageModule(
            facilityEditInfoImageUploadSettings
        );
        facilityEditInfoImageUploadModule.initDataForRequest([
            { key: 'url', value: $('#facility-edit-info-avatar').attr('src') },
        ]);
        facilityEditInfoImageUploadModule.initUploadFile();
        facilityEditInfoImageUploadModule.initDeleteFile();
    };
    var requests = [];
    var fetchFacilitiesByOwner = function () {
        var facilityOwnerId = getCurrentlySelectedFacilityOwner();
        var facilityOwnerName = getCurrentlySelectedFacilityOwnerName();
        var isInternal = getIsInternal();
        hideFacilityEditInformation();
        FacilityEditInformationFunction.blockFacilityEditInfoUI();
        $.each(requests, function (index, request) {
            request.abort();
        });
        requests = [];
        var facilitiesUrl = '/api/facility-edit-information/facilities-by-owner';
        var parameters = {
            facilityOwnerId: facilityOwnerId,
            facilityOwnerName: facilityOwnerName,
            isInternal: isInternal,
        };
        $.ajax({
            type: 'Get',
            url: facilitiesUrl,
            async: true,
            cache: false,
            data: parameters,
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (response) {
                var data = response;
                if (data) {
                    if (data.facilitiesByOwner && data.facilitiesByOwner.length !== 0) {
                        $('.facilitiesByOwnerPlaceHolder').html(data.facilitiesByOwner);
                        /* little fade in effect */
                        $('.facilitiesByOwnerPlaceHolder').fadeIn('fast');
                    }
                }
            },
            error: function (jqXHR, status, exception) {
                console.error(
                    'Something went wrong with the AJAX request for fetching facilities by owner and types!' +
                        '</br>' +
                        exception
                );
                FacilityEditInformationFunction.facilityEditInfoClearContentToModal();
                FacilityEditInformationFunction.facilityEditInfoFillContentToModal(
                    'Något gick fel',
                    'Det gick inte att hämta anläggningar',
                    true,
                    dialogType.error
                );
            },
            complete: function (response) {
                $('#createNewFacility').removeClass('disabled-btn');
                showFacilitiesByOwnersList();
                FacilityEditInformationFunction.unBlockFacilityEditInfoUI();
            },
        });
    };
    var reloadFacilitiesByOwner = function () {
        var selectedFacilityOwner = getCurrentlySelectedFacilityOwner();
        if ($.trim(selectedFacilityOwner) != '') {
            $('#createNewFacility').removeClass('disabled-btn');
            fetchFacilitiesByOwner();
        } else {
            $('#createNewFacility').addClass('disabled-btn');
            hideFacilityEditInformation();
        }
    };
    var getFacilityInformationForEditing = function (selectedFacilityId) {
        var facilityOwnerId = getCurrentlySelectedFacilityOwner();
        var facilityOwnerName = getCurrentlySelectedFacilityOwnerName();
        var isInternal = getIsInternal();
        hideFacilityEditInformation();
        FacilityEditInformationFunction.blockFacilityEditInfoUI();
        $.each(requests, function (index, request) {
            request.abort();
        });
        requests = [];
        var parameters = {
            facilityId: selectedFacilityId,
            facilityOwnerId: facilityOwnerId,
            facilityOwnerName: facilityOwnerName,
            isInternal: isInternal,
        };
        $.ajax({
            type: 'Get',
            url: '/api/facility-edit-information/edit-facility-information',
            async: true,
            cache: false,
            data: parameters,
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (data) {
                if (data) {
                    if (data.facilityInformation && data.facilityInformation.length !== 0) {
                        $('.facilityEditInformationPlaceHolder').html(data.facilityInformation);
                        /* little fade in effect */
                        $('.facilityEditInformationPlaceHolder').fadeIn('fast');
                    }
                    initFacilityEditInfoImageUploadEvent();
                }
            },
            error: function (jqXHR, status, exception) {
                console.error(
                    'Something went wrong with the AJAX request for fetching FacilityEditInformation for editing!' +
                        '</br>' +
                        exception
                );
                FacilityEditInformationFunction.facilityEditInfoClearContentToModal();
                FacilityEditInformationFunction.facilityEditInfoFillContentToModal(
                    'Något gick fel',
                    'Det gick inte att hämta anläggnings info',
                    true,
                    dialogType.error,
                    reloadFacilitiesByOwner
                );
            },
            complete: function (response) {
                showFacilityEditInformation();
                FacilityEditInformationFunction.unBlockFacilityEditInfoUI();
            },
        });
    };
    var fetchAreas = function (facilityAddressType, showAreas) {
        var parentCategoryId = getCurrentlySelectedCountryId(facilityAddressType);
        FacilityEditInformationFunction.blockFacilityEditInfoUI();
        $.each(requests, function (index, request) {
            request.abort();
        });

        $('.facility-address-area-dropdown-' + facilityAddressType).html('');
        $('.facility-address-region-dropdown-' + facilityAddressType).html('');
        $('.FacilityAddressAreaSelection_' + facilityAddressType).addClass('hidden');
        $('.FacilityAddressRegionSelection_' + facilityAddressType).addClass('hidden');

        requests = [];
        var parameters = {
            parentCategoryId: parentCategoryId,
        };
        $.ajax({
            type: 'Get',
            url: '/api/facility-edit-information/facility-sub-categories-by-parent-category',
            async: true,
            cache: false,
            data: parameters,
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (response) {
                if (response) {
                    var subCategories =
                        typeof response.subCategories == 'string'
                            ? JSON.parse(response.subCategories)
                            : response.subCategories;
                    $.each(subCategories, function (index, subCategory) {
                        $('.facility-address-area-dropdown-' + facilityAddressType).append(
                            "<option value='" +
                                subCategory.Value +
                                "'>" +
                                subCategory.Text +
                                '</option>'
                        );
                    });
                }
            },
            error: function (jqXHR, status, exception) {
                console.error(
                    'Something went wrong with the AJAX request for fetching geografiskt områder!' +
                        '</br>' +
                        exception
                );
                FacilityEditInformationFunction.facilityEditInfoClearContentToModal();
                FacilityEditInformationFunction.facilityEditInfoFillContentToModal(
                    'Något gick fel',
                    'Det gick inte att hämta geografiskt områder',
                    true,
                    dialogType.error,
                    reloadFacilitiesByOwner
                );
            },
            complete: function (response) {
                FacilityEditInformationFunction.unBlockFacilityEditInfoUI();
                if (showAreas)
                    $('.FacilityAddressAreaSelection_' + facilityAddressType).removeClass('hidden');
            },
        });
    };
    var fetchRegions = function (facilityAddressType, showRegions) {
        var parentCategoryId = getCurrentlySelectedAreaId(facilityAddressType);
        FacilityEditInformationFunction.blockFacilityEditInfoUI();
        $.each(requests, function (index, request) {
            request.abort();
        });

        $('.facility-address-region-dropdown-' + facilityAddressType).html('');
        $('.FacilityAddressRegionSelection_' + facilityAddressType).addClass('hidden');

        requests = [];
        var parameters = {
            parentCategoryId: parentCategoryId,
        };
        $.ajax({
            type: 'Get',
            url: '/api/facility-edit-information/facility-sub-categories-by-parent-category',
            async: true,
            cache: false,
            data: parameters,
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (response) {
                if (response) {
                    var subCategories =
                        typeof response.subCategories == 'string'
                            ? JSON.parse(response.subCategories)
                            : response.subCategories;
                    $.each(subCategories, function (index, subCategory) {
                        $('.facility-address-region-dropdown-' + facilityAddressType).append(
                            "<option value='" +
                                subCategory.Value +
                                "'>" +
                                subCategory.Text +
                                '</option>'
                        );
                    });
                }
            },
            error: function (jqXHR, status, exception) {
                console.error(
                    'Something went wrong with the AJAX request for fetching regions!' +
                        '</br>' +
                        exception
                );
                FacilityEditInformationFunction.facilityEditInfoClearContentToModal();
                FacilityEditInformationFunction.facilityEditInfoFillContentToModal(
                    'Något gick fel',
                    'Det gick inte att hämta regions',
                    true,
                    dialogType.error,
                    reloadFacilitiesByOwner
                );
            },
            complete: function (response) {
                FacilityEditInformationFunction.unBlockFacilityEditInfoUI();
                if (showRegions)
                    $('.FacilityAddressRegionSelection_' + facilityAddressType).removeClass(
                        'hidden'
                    );
            },
        });
    };

    var getFacilityEditInfoOpeningHours = function (fromHourSelector, toHourSelector) {
        var openingHours = [];
        var daysName = ['Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag', 'Söndag'];
        for (var index = 0; index < 7; index++) {
            var openingHour = {
                Day: daysName[index],
                FromHour: $.trim($('#' + fromHourSelector + index).val()),
                ToHour: $.trim($('#' + toHourSelector + index).val()),
            };
            openingHours.push(openingHour);
        }
        return openingHours;
    };
    var validateFacilityEditInfoOpeningHours = function (openingHours, period, arr) {
        for (var index = 0; index < openingHours.length; index++) {
            var openingHour = openingHours[index];
            if ($.trim(openingHour.FromHour) == '' && $.trim(openingHour.ToHour) != '') {
                arr[arr.length] =
                    '<li>' + period + ': ' + openingHour.Day + ' Från tim måste ange.</li>';
            } else if ($.trim(openingHour.FromHour) != '' && $.trim(openingHour.ToHour) == '') {
                arr[arr.length] =
                    '<li>' + period + ': ' + openingHour.Day + ' Till tim måste ange.</li>';
            } else if ($.trim(openingHour.FromHour) != '' && $.trim(openingHour.ToHour) != '') {
                var fromHour = parseInt($.trim(openingHour.FromHour.replace(/_/g, '')));
                var toHour = parseInt($.trim(openingHour.ToHour.replace(/_/g, '')));
                if (fromHour == 0) fromHour = 2400;
                if (toHour == 0) toHour = 2400;
                if (toHour < fromHour) {
                    arr[arr.length] =
                        '<li>' +
                        period +
                        ': ' +
                        openingHour.Day +
                        ' Till tim måste vara större än Från tim.</li>';
                }
            }
        }
    };
    var validateFacilityEditAddress = function (facilityAddress, arr) {
        var rePhone = /^((((0{2}?)|(\+){1})46)|0)7[\d]{8}/;
        var facilityAddressErrorSource =
            facilityAddress.AddressType ==
            FacilityEditInformationFunction.facilityAddressTypeEnum.PrimaryAddress
                ? 'Primär adress '
                : 'Sekundär adress ';
        if ($.trim(facilityAddress.VisitingAddress) == '') {
            arr[arr.length] =
                '<li>' + facilityAddressErrorSource + 'besöksadress saknar värde.</li>';
        } else if (
            $.trim(facilityAddress.VisitingAddress) != '' &&
            $.trim(facilityAddress.VisitingAddress).length > 255
        ) {
            arr[arr.length] =
                '<li>' + facilityAddressErrorSource + 'besöksadress kan vara max 255 tecken.</li>';
        }

        if ($.trim(facilityAddress.Region) != '' && $.trim(facilityAddress.Region).length > 50) {
            arr[arr.length] =
                '<li>' + facilityAddressErrorSource + 'region kan vara max 50 tecken.</li>';
        }

        if ($.trim(facilityAddress.ZipCode) == '') {
            arr[arr.length] = '<li>' + facilityAddressErrorSource + 'postnummer saknar värde.</li>';
        } else if (
            $.trim(facilityAddress.ZipCode) != '' &&
            $.trim(facilityAddress.ZipCode).length > 20
        ) {
            arr[arr.length] =
                '<li>' + facilityAddressErrorSource + 'postnummer kan vara max 20 tecken.</li>';
        }

        if ($.trim(facilityAddress.City) == '') {
            arr[arr.length] = '<li>' + facilityAddressErrorSource + 'ort saknar värde.</li>';
        } else if ($.trim(facilityAddress.City) != '' && $.trim(facilityAddress.City).length > 50) {
            arr[arr.length] =
                '<li>' + facilityAddressErrorSource + 'ort kan vara max 50 tecken.</li>';
        }

        if ($.trim(facilityAddress.CountryId) == '')
            arr[arr.length] = '<li>' + facilityAddressErrorSource + 'land saknar värde.</li>';
        if ($.trim(facilityAddress.Latitude) == '') {
            arr[arr.length] = '<li>' + facilityAddressErrorSource + 'latitude saknar värde.</li>';
        } else if (
            $.trim(facilityAddress.Latitude) != '' &&
            $.trim(facilityAddress.Latitude).length > 20
        ) {
            arr[arr.length] =
                '<li>' + facilityAddressErrorSource + 'latitude kan vara max 20 tecken.</li>';
        }
        if ($.trim(facilityAddress.Longitude) == '') {
            arr[arr.length] = '<li>' + facilityAddressErrorSource + 'longitude saknar värde.</li>';
        } else if (
            $.trim(facilityAddress.Longitude) != '' &&
            $.trim(facilityAddress.Longitude).length > 20
        ) {
            arr[arr.length] =
                '<li>' + facilityAddressErrorSource + 'longitude kan vara max 20 tecken.</li>';
        }
        if (
            $.trim(facilityAddress.PhoneNumber) != '' &&
            $.trim(facilityAddress.PhoneNumber).length > 20
        ) {
            arr[arr.length] = '<li>Telefonnummer kan vara max 20 tecken.</li>';
        }
    };

    var getFacilityEditAddressPayload = function (facilityId, facilityName, facilityAddressType) {
        var facilityAddress = {
            FacilityId: facilityId,
            FacilityName: facilityName,
            AddressType: facilityAddressType,
            VisitingAddress: $.trim(
                $("input[id='FacilityAddressVisitingAddress1_" + facilityAddressType + "']").val()
            ),
            VisitingAddress2: $.trim(
                $("input[id='FacilityAddressVisitingAddress2_" + facilityAddressType + "']").val()
            ),
            ZipCode: $.trim(
                $("input[id='FacilityAddressZipCode_" + facilityAddressType + "']").val()
            ),
            City: $.trim($("input[id='FacilityAddressCity_" + facilityAddressType + "']").val()),
            CountryId: $.trim(getCurrentlySelectedCountryId(facilityAddressType)),
            AreaId: $.trim(getCurrentlySelectedAreaId(facilityAddressType)),
            RegionId: $.trim(getCurrentlySelectedRegionId(facilityAddressType)),
            Country: '',
            Area: '',
            Region: '',
            Latitude: $.trim(
                $("input[id='FacilityAddressLatitude_" + facilityAddressType + "']").val()
            ),
            Longitude: $.trim(
                $("input[id='FacilityAddressLongitude_" + facilityAddressType + "']").val()
            ),
            PhoneNumber: $.trim(
                $("input[id='FacilityAddressPhoneNumber_" + facilityAddressType + "']").val()
            ),
        };
        if ($.trim(facilityAddress.CountryId) != '')
            facilityAddress.Country = $.trim(getCurrentlySelectedCountry(facilityAddressType));
        if ($.trim(facilityAddress.AreaId) != '')
            facilityAddress.Area = $.trim(getCurrentlySelectedArea(facilityAddressType));
        if ($.trim(facilityAddress.RegionId) != '')
            facilityAddress.Region = $.trim(getCurrentlySelectedRegion(facilityAddressType));
        return facilityAddress;
    };
    var getFacilityEditInformationPayload = function () {
        var payload = {
            FacilityId: getCurrentlySelectedFacilityId(),
            FacilityName: $.trim($("input[id='FacilityEditInfoName']").val()),
            FacilityOwnerId: getCurrentlySelectedFacilityOwner(),
            FacilityOwnerName: getCurrentlySelectedFacilityOwnerName(),
            FacilityType: getCurrentlySelectedFacilityType(),
            FacilityPropertyType: getCurrentlySelectedFacilityPropertyType(),
            LanguageCode: $.trim(getCurrentlySelectedLanguageCode()),
            Language: $.trim(getCurrentlySelectedLanguage()),
            FacilityInfoSource: $.trim($("input[id='FacilityEditInfoSource']").val()),
            ShowFacilityInfo: getShowFacilityInfo(),
            ExtraPhoneNumber: $.trim($("input[id='FacilityEditInfoExtraPhoneNumber']").val()),
            PhoneBooking: $.trim($("input[id='FacilityEditInfoPhoneBooking']").val()),
            PhoneAnsweringMachine: $.trim(
                $("input[id='FacilityEditInfoPhoneAnsweringMachine']").val()
            ),
            Fax: $.trim($("input[id='FacilityEditInfoFax']").val()),
            Email: $.trim($("input[id='FacilityEditInfoEmail']").val()),
            Website: $.trim($("input[id='FacilityEditInfoWebsite']").val()),
            OtherInformation: $.trim($("textArea[id='FacilityEditInfoOtherInformation']").val()),
            NormalPeriod: {
                OpeningHours: getFacilityEditInfoOpeningHours(
                    'FacilityEditInfoNormalPeriodFromHour_',
                    'FacilityEditInfoNormalPeriodToHour_'
                ),
            },
            HarvestPeriod: {
                FromDate: $.trim($('#FacilityEditInfoHarvestPeriodFromDate').val()),
                ToDate: $.trim($('#FacilityEditInfoHarvestPeriodToDate').val()),
                OtherInformation: $.trim($('#FacilityEditInfoHarvestPeriodOtherInformation').val()),
                OpeningHours: getFacilityEditInfoOpeningHours(
                    'FacilityEditInfoHarvestPeriodFromHour_',
                    'FacilityEditInfoHarvestPeriodToHour_'
                ),
            },
            FacilityImageUrl: $('#facility-edit-info-avatar').attr('src'),
            ConnectedContactPersonIds: getConnectedContactPersonIds(),
        };
        payload.PrimaryAddress = getFacilityEditAddressPayload(
            payload.FacilityId,
            payload.FacilityName,
            FacilityEditInformationFunction.facilityAddressTypeEnum.PrimaryAddress
        );

        if (!FacilityEditInformationFunction.isSecondaryAddressActivated()) {
            FacilityEditInformationFunction.inactivateSecondaryAddress();
        }

        payload.SecondaryAddress = getFacilityEditAddressPayload(
            payload.FacilityId,
            payload.FacilityName,
            FacilityEditInformationFunction.facilityAddressTypeEnum.SecondaryAddress
        );

        if ($.trim(payload.WarehouseType) == '') payload.WarehouseType = 'Z1';
        if ($.trim(payload.WarehouseSubType) == '') payload.WarehouseSubType = '1';
        return payload;
    };
    var isFacilityAddressEmpty = function (facilityAddressType) {
        var facilityAddress = getFacilityEditAddressPayload('', '', facilityAddressType);

        return (
            $.trim(facilityAddress.VisitingAddress) == '' &&
            $.trim(facilityAddress.ZipCode) == '' &&
            $.trim(facilityAddress.City) == '' &&
            $.trim(facilityAddress.CountryId) == '' &&
            $.trim(facilityAddress.AreaId) == '' &&
            $.trim(facilityAddress.RegionId) == '' &&
            $.trim(facilityAddress.Latitude) == '' &&
            $.trim(facilityAddress.Longitude) == ''
        );
    };
    var validateSaveFacilityEditInformation = function (data) {
        var arr = [];
        var rePhone = /^((((0{2}?)|(\+){1})46)|0)7[\d]{8}/;
        var reEmail =
            /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        var reWebsite =
            /^(http(s)?:\/\/)(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#()?&//=]*)$/;

        if ($.trim(data.FacilityName) == '') {
            arr[arr.length] = '<li>Anläggningsnamn saknar värde.</li>';
        } else if ($.trim(data.FacilityName).length > 255) {
            arr[arr.length] = '<li>Anläggningsnamn  kan vara max 255 tecken.</li>';
        }
        if ($.trim(data.FacilityOwnerId) == '') {
            arr[arr.length] = '<li>Företag saknar värde.</li>';
        }
        if ($.trim(data.FacilityType) == '') {
            arr[arr.length] = '<li>Anläggningstyp saknar värde.</li>';
        }
        if ($.trim(data.FacilityPropertyType) == '') {
            arr[arr.length] = '<li>Tillhörighet saknar värde.</li>';
        }
        if ($.trim(data.LanguageCode) == '') {
            arr[arr.length] = '<li>Språkkod saknar värde.</li>';
        }
        validateFacilityEditAddress(data.PrimaryAddress, arr);

        if (FacilityEditInformationFunction.isSecondaryAddressActivated()) {
            validateFacilityEditAddress(data.SecondaryAddress, arr);
        }
        if ($.trim(data.ExtraPhoneNumber) != '' && $.trim(data.ExtraPhoneNumber).length > 20) {
            arr[arr.length] = '<li>Extra telefonnummer kan vara max 20 tecken.</li>';
        }
        if ($.trim(data.PhoneBooking) != '' && $.trim(data.PhoneBooking).length > 50) {
            arr[arr.length] = '<li>Tidsbokning kan vara max 50 tecken.</li>';
        }
        if (
            $.trim(data.PhoneAnsweringMachine) != '' &&
            $.trim(data.PhoneAnsweringMachine).length > 20
        ) {
            arr[arr.length] = '<li>Telefonsvarare kan vara max 20 tecken.</li>';
        }
        if ($.trim(data.Fax) != '' && $.trim(data.Fax).length > 20) {
            arr[arr.length] = '<li>Fax kan vara max 20 tecken.</li>';
        }
        var email = $.trim(data.Email);
        if (email !== '' && (email.length > 255 || !reEmail.test(email))) {
            arr[arr.length] = '<li>Ange ett giltigt e-post adress.</li>';
        }
        var website = $.trim(data.Website);
        if (website !== '' && (website.length > 255 || !reWebsite.test(website))) {
            arr[arr.length] = '<li>Ange ett giltigt webbplats adress.</li>';
        }
        if ($.trim(data.OtherInformation) != '' && $.trim(data.OtherInformation).length > 1200) {
            arr[arr.length] = '<li>Övrigt kan vara max 1200 tecken.</li>';
        }
        if ($.trim(data.HarvestPeriod.FromDate) == '' && $.trim(data.HarvestPeriod.ToDate) != '') {
            arr[arr.length] = '<li>Från datum måste ange.</li>';
        } else if (
            $.trim(data.HarvestPeriod.FromDate) != '' &&
            $.trim(data.HarvestPeriod.ToDate) == ''
        ) {
            arr[arr.length] = '<li>Till datum måste ange.</li>';
        } else if (
            $.trim(data.HarvestPeriod.FromDate) != '' &&
            $.trim(data.HarvestPeriod.ToDate) != ''
        ) {
            var fromDate = new Date(data.HarvestPeriod.FromDate);
            var toDate = new Date(data.HarvestPeriod.ToDate);
            if (toDate < fromDate) {
                arr[arr.length] = '<li>Till datum måste vara större än Från datum.</li>';
            }
        }
        if (
            $.trim(data.HarvestPeriod.OtherInformation) != '' &&
            $.trim(data.HarvestPeriod.OtherInformation).length > 1200
        ) {
            arr[arr.length] = '<li>Info ändrade öppettider kan vara max 1200 tecken.</li>';
        }
        validateFacilityEditInfoOpeningHours(data.NormalPeriod.OpeningHours, 'Normal Period', arr);
        validateFacilityEditInfoOpeningHours(
            data.HarvestPeriod.OpeningHours,
            'Harvest Period',
            arr
        );
        return arr;
    };
    var saveFacilityInformation = function () {
        $.each(requests, function (index, request) {
            request.abort();
        });

        requests = [];

        var facilityEditInformationPayload = getFacilityEditInformationPayload();

        if (
            FacilityEditInformationFunction.validateFacilityEditInfoSave(
                facilityEditInformationPayload
            )
        ) {
            showSaveFacilityInformationLoader();
            FacilityEditInformationFunction.disableFacilityEditInfoButtons();
            var isInternal = getIsInternal();
            $.ajax({
                type: 'POST',
                url: '/api/facility-edit-information/save-facility-information',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                async: true,
                cache: false,
                data: JSON.stringify({
                    facilityInformation: facilityEditInformationPayload,
                    isInternal: isInternal,
                }),
                success: function (response) {
                    FacilityEditInformationFunction.enableFacilityEditInfoButtons();
                    FacilityEditInformationFunction.facilityEditInfoClearContentToModal();
                    if (response) {
                        FacilityEditInformationFunction.facilityEditInfoFillContentToModal(
                            'Anläggning sparad',
                            '',
                            true,
                            dialogType.error,
                            reloadFacilitiesByOwner
                        );
                    } else {
                        FacilityEditInformationFunction.facilityEditInfoFillContentToModal(
                            'Fel att spara anläggning',
                            '',
                            true,
                            dialogType.error
                        );
                    }
                },
                error: function () {
                    FacilityEditInformationFunction.enableFacilityEditInfoButtons();
                    FacilityEditInformationFunction.facilityEditInfoClearContentToModal();
                    FacilityEditInformationFunction.facilityEditInfoFillContentToModal(
                        'Fel att spara anläggning',
                        '',
                        true,
                        dialogType.error
                    );
                },
                complete: function (response) {
                    FacilityEditInformationFunction.enableFacilityEditInfoButtons();
                    hideSaveFacilityInformationLoader();
                },
            });
        } else {
            var errors = validateSaveFacilityEditInformation(facilityEditInformationPayload);
            if (errors.length > 0) {
                FacilityEditInformationFunction.facilityEditInfoClearContentToModal();
                var errorContent = $('<p></p>').append('<ul>' + errors.join('') + '</ul>');
                FacilityEditInformationFunction.facilityEditInfoFillContentToModal(
                    '',
                    errorContent,
                    true,
                    dialogType.error
                );
            }
        }
    };
    var createNewFacilityInformation = function () {
        var isInternal = getIsInternal();
        var facilityOwner = getCurrentlySelectedFacilityOwner();
        var facilityOwnerName = getCurrentlySelectedFacilityOwnerName();

        hideFacilityEditInformation();
        FacilityEditInformationFunction.blockFacilityEditInfoUI();
        $('#createNewFacility').addClass('disabled-btn');

        $.each(requests, function (index, request) {
            request.abort();
        });
        requests = [];

        $.ajax({
            type: 'Post',
            url: '/api/facility-edit-information/create-new-facility',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            async: true,
            cache: false,
            data: JSON.stringify({
                facilityOwnerId: facilityOwner,
                facilityOwnerName: facilityOwnerName,
                isInternal: isInternal,
            }),
            success: function (data) {
                if (data) {
                    if (data.facilityInformation && data.facilityInformation.length !== 0) {
                        $('.facilityEditInformationPlaceHolder').html(data.facilityInformation);
                        /* little fade in effect */
                        $('.facilityEditInformationPlaceHolder').fadeIn('fast');
                    }
                    initFacilityEditInfoImageUploadEvent();
                }
            },
            error: function (jqXHR, status, exception) {
                console.error(
                    'Something went wrong with the AJAX request for fetching FacilityEditInformation for editing!' +
                        '</br>' +
                        exception
                );
                FacilityEditInformationFunction.facilityEditInfoClearContentToModal();
                FacilityEditInformationFunction.facilityEditInfoFillContentToModal(
                    'Det gick inte att skapa ny anläggning',
                    '',
                    true,
                    dialogType.error
                );
            },
            complete: function (response) {
                showFacilityEditInformation();
                FacilityEditInformationFunction.unBlockFacilityEditInfoUI();
            },
        });
    };
    var deleteFacilityInformation = function (selectedFacilityId) {
        FacilityEditInformationFunction.disableFacilityEditInfoButtons();
        FacilityEditInformationFunction.blockFacilityEditInfoUI();
        $.each(requests, function (index, request) {
            request.abort();
        });
        requests = [];
        $.ajax({
            type: 'POST',
            url: '/api/facility-edit-information/delete-facility-information',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            async: true,
            cache: false,
            data: JSON.stringify({
                facilityOwner: getCurrentlySelectedFacilityOwner(),
                facilityId: selectedFacilityId,
            }),
            success: function (response) {
                FacilityEditInformationFunction.facilityEditInfoClearContentToModal();
                if (response) {
                    FacilityEditInformationFunction.facilityEditInfoFillContentToModal(
                        'Anläggning har tagits bort',
                        '',
                        true,
                        dialogType.error,
                        reloadFacilitiesByOwner
                    );
                } else {
                    FacilityEditInformationFunction.facilityEditInfoFillContentToModal(
                        'Fel uppstod när anläggningen skulle tas bort.',
                        '',
                        true,
                        dialogType.error
                    );
                }
            },
            error: function () {
                FacilityEditInformationFunction.facilityEditInfoClearContentToModal();
                FacilityEditInformationFunction.facilityEditInfoFillContentToModal(
                    'Det gick inte att tabort anläggning',
                    '',
                    true,
                    dialogType.error
                );
            },
            complete: function (response) {
                FacilityEditInformationFunction.enableFacilityEditInfoButtons();
                FacilityEditInformationFunction.unBlockFacilityEditInfoUI();
            },
        });
    };

    var fetchFacilityAddressCoordinates = function (facilityAddressType) {
        $.each(requests, function (index, request) {
            request.abort();
        });
        requests = [];

        //clear existing coordinates
        $('#FacilityAddressLatitude_' + facilityAddressType).val('');
        $('#FacilityAddressLongitude_' + facilityAddressType).val('');

        var address = $('#FacilityAddressVisitingAddress1_' + facilityAddressType).val();
        var zipCode = $('#FacilityAddressZipCode_' + facilityAddressType)
            .val()
            .replace(' ', '');
        var city = $('#FacilityAddressCity_' + facilityAddressType).val();
        if (address && zipCode && city) {
            FacilityEditInformationFunction.disableFacilityEditInfoButtons();
            FacilityEditInformationFunction.blockFacilityEditInfoUI();
            var url =
                'https://maps.googleapis.com/maps/api/geocode/json?address=' +
                address +
                ',' +
                zipCode +
                '%20' +
                city +
                '&key=' +
                $('#FacilityAddressGoogleMapsAPIKey_' + facilityAddressType).val();
            $.ajax({
                type: 'POST',
                url: url,
                success: function (data) {
                    if (data.status === google.maps.GeocoderStatus.OK) {
                        if (data.results[0]) {
                            var lat = data.results[0].geometry.location.lat.toFixed(6);
                            var lng = data.results[0].geometry.location.lng.toFixed(6);

                            var latLng = new google.maps.LatLng(lat, lng);

                            var facilityAddressMap =
                                FacilityEditInformationFunction.getFacilityAddressMap(
                                    facilityAddressType
                                );

                            var facilityAddressMarker = new google.maps.Marker({
                                position: latLng,
                                map: facilityAddressMap,
                            });

                            FacilityEditInformationFunction.markFacilityAddressLocation(
                                facilityAddressMarker,
                                facilityAddressType
                            );
                        }
                    } else if (data.status === google.maps.GeocoderStatus.ZERO_RESULTS) {
                        //$("#modal-geocode-zero-results").fadeIn("fast");
                        FacilityEditInformationFunction.facilityEditInfoClearContentToModal();
                        FacilityEditInformationFunction.facilityEditInfoFillContentToModal(
                            'koordinaterna hittades inte.',
                            'Den angivna adressen kunde inte hittas. Verifiera att adressen är korrekt. Du kan också ange koordinaterna manuellt eller klicka på kartan för att hämta ut koordinaterna.',
                            true,
                            dialogType.error
                        );
                    }
                },
                error: function () {
                    FacilityEditInformationFunction.facilityEditInfoClearContentToModal();
                    FacilityEditInformationFunction.facilityEditInfoFillContentToModal(
                        'koordinaterna hittades inte.',
                        'Den angivna adressen kunde inte hittas. Verifiera att adressen är korrekt. Du kan också ange koordinaterna manuellt eller klicka på kartan för att hämta ut koordinaterna.',
                        true,
                        dialogType.error
                    );
                },
                complete: function (response) {
                    FacilityEditInformationFunction.enableFacilityEditInfoButtons();
                    FacilityEditInformationFunction.unBlockFacilityEditInfoUI();
                },
            });
        } else {
            FacilityEditInformationFunction.facilityEditInfoClearContentToModal();
            FacilityEditInformationFunction.facilityEditInfoFillContentToModal(
                'koordinaterna hittades inte.',
                'Ange Gatuadress,Postnummer och Ort för att hämta koordinaterna.',
                true,
                dialogType.error
            );
        }
    };
    var fetchFacilitiesByOwnerEvent = function () {
        $('.facility-owner-dropdown').on('change', function () {
            FacilityEditInformationFunction.clearFacilityEditInfoValidations();
            FacilityEditInformationFunction.facilityEditInfoClearContentToModal();
            $('#createNewFacility').addClass('disabled-btn');
            var selectedFacilityOwner = getCurrentlySelectedFacilityOwner();
            if ($.trim(selectedFacilityOwner) != '') {
                fetchFacilitiesByOwner();
            } else {
                hideFacilityEditInformation();
            }
        });
    };
    var getFacilityInformationForEditingEvent = function () {
        $(document).on('click', '.facility-edit-info', function (event) {
            FacilityEditInformationFunction.clearFacilityEditInfoValidations();
            FacilityEditInformationFunction.facilityEditInfoClearContentToModal();
            var selectedFacilityId = $(this).data('facilityid');
            $('#createNewFacility').addClass('disabled-btn');
            getFacilityInformationForEditing(selectedFacilityId);
        });
    };
    var saveFacilityInformationEvent = function () {
        $(document).on('click', '#saveFacilityInfoBtn', function (event) {
            saveFacilityInformation();
        });
    };
    var createNewFacilityInformationEvent = function () {
        $(document).on('click', '#createNewFacility', function (event) {
            createNewFacilityInformation();
        });
    };
    var cancelFacilityInformationEvent = function () {
        $(document).on('click', '#cancelFacilityInfoBtn', function (event) {
            var content = $('<p></p>').append('Alla förändringar kommer att förloras!');
            FacilityEditInformationFunction.facilityEditInfoClearContentToConfirmDialog();
            FacilityEditInformationFunction.facilityEditInfoFillContentToConfirmDialog(
                'Vill du verkligen avbryt ändringar?',
                content,
                reloadFacilitiesByOwner
            );
        });
    };
    var deleteFacilityInformationEvent = function () {
        $(document).on('click', '.facility-delete-info', function (event) {
            var selectedFacilityName = $(this).data('facilityname');
            var selectedFacilityId = $(this).data('facilityid');
            var content = $('<p></p>').append(
                'Vill du verkligen ta bort anläggning <strong>' +
                    selectedFacilityName +
                    '</strong>?'
            );
            FacilityEditInformationFunction.facilityEditInfoClearContentToConfirmDialog();
            FacilityEditInformationFunction.facilityEditInfoFillContentToConfirmDialog(
                '',
                content,
                deleteFacilityInformation.bind(null, selectedFacilityId)
            );
        });
    };
    var fetchFacilityAddressCoordinatesEvent = function () {
        $(document).on('click', '.js-get-coordinates', function () {
            FacilityEditInformationFunction.clearFacilityEditInfoValidations();
            FacilityEditInformationFunction.facilityEditInfoClearContentToModal();
            var facilityAddressType = $(this).val();
            fetchFacilityAddressCoordinates(facilityAddressType);
        });
    };

    var activateSecondaryAddressEvent = function () {
        $(document).on('change', '.active-secondary_address', function (event) {
            FacilityEditInformationFunction.facilityEditInfoClearContentToConfirmDialog();
            var self = this;
            if ($(self).is(':checked')) {
                $('.js-secondary-address').removeClass('hidden');
            } else {
                if (
                    !isFacilityAddressEmpty(
                        FacilityEditInformationFunction.facilityAddressTypeEnum.SecondaryAddress
                    )
                ) {
                    var content = $('<p></p>').append('Alla adress info kommer att förloras!');
                    FacilityEditInformationFunction.facilityEditInfoFillContentToConfirmDialog(
                        'Är du säker om inaktivera sekundrär adress?',
                        content,
                        FacilityEditInformationFunction.inactivateSecondaryAddress,
                        function () {
                            $(self).prop('checked', true);
                        }
                    );
                } else {
                    FacilityEditInformationFunction.inactivateSecondaryAddress();
                }
            }
        });
    };
    var selectAllFacilityTypesEvent = function () {
        $(document).on('change', '.js-select-all-facility-types', function (event) {
            var isChecked = $(this).is(':checked');
            $('input[name="facilityTypes[]"]').prop('checked', isChecked);
        });
    };
    var fetchAreasEvent = function (facilityAddressType) {
        $(document).on(
            'change',
            '.facility-address-country-dropdown-' + facilityAddressType,
            function (event, data) {
                FacilityEditInformationFunction.clearFacilityEditInfoValidations();
                FacilityEditInformationFunction.facilityEditInfoClearContentToModal();
                fetchAreas(facilityAddressType, data ? data.showAreas : true);
            }
        );
    };
    var fetchRegionsEvent = function (facilityAddressType) {
        $(document).on(
            'change',
            '.facility-address-area-dropdown-' + facilityAddressType,
            function (event, data) {
                FacilityEditInformationFunction.clearFacilityEditInfoValidations();
                FacilityEditInformationFunction.facilityEditInfoClearContentToModal();
                fetchRegions(facilityAddressType, data ? data.showRegions : true);
            }
        );
    };
    var fetchFacilityContactPersonInformation = function () {
        var contactPersonId = getCurrentlySelectedFacilityContactPersonId();
        var facilityId = getCurrentlySelectedFacilityId();
        var isInternal = getIsInternal();
        hideFacilityContactPersonInformation();
        showFacilityContactPersonInformationLoader();
        $.each(requests, function (index, request) {
            request.abort();
        });
        requests = [];
        var facilityContactPersonInformationUrl =
            '/api/facility-edit-information/facility-contact-person-information';
        var facilityContactPersonConnectionUrl =
            '/api/facility-edit-information/facility-contact-person-connection';

        var facilityContactPersonInformationDeferred = $.ajax({
            type: 'Get',
            url: facilityContactPersonInformationUrl,
            async: true,
            cache: false,
            data: { contactPersonId: contactPersonId, isInternal: isInternal },
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (data) {
                if (data) {
                    $('.js-facility-contact-person-information')[0].setAttribute(
                        'contactpersonid',
                        contactPersonId
                    );
                    if (
                        data.facilityContactPersonInformation &&
                        data.facilityContactPersonInformation.length !== 0
                    ) {
                        $('.facilityContactPersonInformationPlaceHolder').html(
                            data.facilityContactPersonInformation
                        );
                        $('.selected-contact-person-name').html(
                            getCurrentlySelectedFacilityContactPersonName()
                        );
                        /* little fade in effect */
                        $('.facilityContactPersonInformationPlaceHolder').fadeIn('fast');
                    }
                }
            },
            error: function (jqXHR, status, exception) {
                console.error(
                    'Something went wrong with the AJAX request for fetching FacilityContactPersonInformation!' +
                        '</br>' +
                        exception.Message
                );
                $('.facilityContactPersonInformationPlaceHolder').html(
                    '<h2>Failed to fetch facility contact person information</h2>'
                );
            },
        });
        var facilityContactPersonConnectionDeferred = $.ajax({
            type: 'Get',
            url: facilityContactPersonConnectionUrl,
            async: true,
            cache: false,
            data: { facilityId: facilityId, contactPersonId: contactPersonId },
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (data) {
                if (data) {
                    var isContactPersonConnected = data.isContactPersonConnected;
                    if (isContactPersonConnected) {
                        $('.js-facility-contact-person-information').addClass('active');
                    } else {
                        $('.js-facility-contact-person-information').removeClass('active');
                    }
                    $('.js-facility-contact-person-information')[0].setAttribute(
                        'contactpersonid',
                        contactPersonId
                    );
                }
            },
            error: function (jqXHR, status, exception) {
                console.error(
                    'Something went wrong with the AJAX request for fetching FacilityContactPersonConnection!' +
                        '</br>' +
                        exception.Message
                );
            },
        });
        requests.push(facilityContactPersonInformationDeferred);
        requests.push(facilityContactPersonConnectionDeferred);
        $.when.apply($, requests).then(function () {
            hideFacilityContactPersonInformationLoader();
            showFacilityContactPersonInformation();
        });
    };
    var connectContactPersonToFacility = function (contactPersonId, isNewConnection) {
        var facilityId = getCurrentlySelectedFacilityId();
        var isInternal = getIsInternal();
        showFacilityContactPersonsLoader();
        $.each(requests, function (index, request) {
            request.abort();
        });
        requests = [];
        var tableResult = $('#facility-connected-contact-persons');
        $.ajax({
            url: '/api/facility-edit-information/connect-contact-person-to-facility',
            type: 'POST',
            async: true,
            cache: false,
            data: JSON.stringify({
                facilityId: facilityId,
                contactPersonId: contactPersonId,
                isNewConnection: isNewConnection,
                isInternal: isInternal,
            }),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (data) {
                hideFacilityContactPersonsLoader();
                if (data) {
                    if (
                        data.facilityConnectedContactPersons &&
                        data.facilityConnectedContactPersons.length !== 0
                    ) {
                        tableResult.html(data.facilityConnectedContactPersons);
                        /* little fade in effect */
                        tableResult.fadeIn('fast');
                        if (
                            !$('.js-hide-show-facility-contact-person-information').hasClass(
                                'hidden'
                            ) &&
                            $('.js-facility-contact-person-information')[0].getAttribute(
                                'contactpersonid'
                            ) == contactPersonId
                        ) {
                            if (isNewConnection) {
                                if (
                                    !$('.js-facility-contact-person-information').hasClass('active')
                                )
                                    $('.js-facility-contact-person-information').addClass('active');
                            } else if (
                                $('.js-facility-contact-person-information').hasClass('active')
                            ) {
                                $('.js-facility-contact-person-information').removeClass('active');
                            }
                        }
                    }
                }
            },
            error: function (jqXHR, status, exception) {
                console.error(
                    'Something went wrong with the AJAX request for connecting contact person to facility!' +
                        '</br>' +
                        exception.Message
                );
                tableResult.empty();
                hideFacilityContactPersonsLoader();
            },
        });
        return false;
    };
    var fetchFacilityContactPersonInformationEvent = function () {
        $(document).on('change', '.facility-contact-person-dropdown', function (event, data) {
            fetchFacilityContactPersonInformation();
        });
    };
    var connectContactPersonToFacilityEvent = function (obj, contactPersonId) {
        if ($(obj).hasClass('active')) {
            connectContactPersonToFacility(contactPersonId, false);
            $(obj).toggleClass('active');
        } else {
            connectContactPersonToFacility(contactPersonId, true);
            $(obj).toggleClass('active');
        }
    };
    var facilityContactPersonInformationClickEvent = function () {
        $(document).on('click', '.js-facility-contact-person-information', function (e) {
            e.stopPropagation();
            e.preventDefault();
            var contactPersonId = $(this)[0].getAttribute('contactpersonid');
            connectContactPersonToFacilityEvent($(this), contactPersonId);
        });
    };
    var facilityConnectedContactPersonsClickEvent = function () {
        $(document).on('click', '.js-facility-connected-contact-persons', function (e) {
            e.stopPropagation();
            e.preventDefault();
            var contactPersonId = $(this).data('contactpersonid');
            connectContactPersonToFacilityEvent($(this), contactPersonId);
        });
    };
    var init = function () {
        fetchFacilitiesByOwnerEvent();
        getFacilityInformationForEditingEvent();
        createNewFacilityInformationEvent();
        saveFacilityInformationEvent();
        deleteFacilityInformationEvent();
        cancelFacilityInformationEvent();
        fetchFacilityAddressCoordinatesEvent();
        activateSecondaryAddressEvent();
        selectAllFacilityTypesEvent();
        fetchAreasEvent(FacilityEditInformationFunction.facilityAddressTypeEnum.PrimaryAddress);
        fetchAreasEvent(FacilityEditInformationFunction.facilityAddressTypeEnum.SecondaryAddress);
        fetchRegionsEvent(FacilityEditInformationFunction.facilityAddressTypeEnum.PrimaryAddress);
        fetchRegionsEvent(FacilityEditInformationFunction.facilityAddressTypeEnum.SecondaryAddress);
        fetchFacilityContactPersonInformationEvent();
        facilityContactPersonInformationClickEvent();
        facilityConnectedContactPersonsClickEvent();
    };
    return {
        init: init,
    };
};
